import CheckoutNavigationMixin from '~/app/CheckoutNavigationMixin'

export default {
  mixins: [CheckoutNavigationMixin],
  computed: {
    currentStep: function() {
      return this.$store.state.cart.checkout.currentStep
    },
  },
}
